import { axiosClient } from './axios/axiosClient';

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosClient.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadFileToServer = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosClient.post('/files/upload-document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
